/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'confluence-analytics-chart.default-loading-text': '분석 데이터 새로 고치는 중...',
  'confluence-analytics-chart.tooltip.no-views-data': '데이터 없음',
  'confluence-analytics-chart.tooltip.views-overall': '{count, plural, other {조회수 {count}회}}',
  'confluence-analytics-chart.tooltip.views-today-so-far': '{count, plural, other {지금까지의 조회수 {count}회}}',
  'confuence-analytics-chart.accessible-table.caption': '페이지 조회수',
  'confuence-analytics-chart.accessible-table.header.date': '날짜',
  'confuence-analytics-chart.accessible-table.header.view-count': '조회수',
  'confuence-analytics-chart.accessible-table.no-view-count-data': '조회수 없음',
};
